import React from 'react';
var toHTML = str => ({
  __html: str
});
function PlainHtmlRenderer(_ref) {
  var {
    html,
    classes
  } = _ref;
  // Even if empty, render a div with no content, for styling purposes.
  if (!html) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.root
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    dangerouslySetInnerHTML: toHTML(html)
  });
}
export var canRender = () => true; // backstop component, always renders
export var Component = PlainHtmlRenderer;